const PAYMENT_FORM_ERRORS = ["declined", "unconfirmed"] as const;

export type PaymentFormError = (typeof PAYMENT_FORM_ERRORS)[number];

export const PaymentFormError = {
	DECLINED: "declined",
	UNCONFIRMED: "unconfirmed",
} as const satisfies Record<Uppercase<PaymentFormError>, PaymentFormError>;

export type GatewayPaymentError =
	| {
			type: string;
			code?: string;
			decline_code?: string;
			message?: string;
	  }
	| {
			message: string;
			authorizeNetDeclineCode?: string;
	  }
	| undefined;
